import React from 'react';
import { UserTableFields } from '../../../models/user/user';

import { toShortLocalDate, toLocalShortDateTime } from '../../../helpers/dateHelper';
import { CustomColumnType } from '../../common/table/CustomTable.types';
import { ClickableRow } from '../../../styles/common.styles';
import { NavLink } from 'react-router-dom';
import { UsersTableEmail, UsersTableGraySpan } from './UsersTable.styles';
import { CrownOutlined } from '@ant-design/icons';

export const columns: CustomColumnType<UserTableFields>[] = [
    {
        title: 'Last name',
        dataIndex: 'lastName',
        sorter: true,
        clickable: true,
        render: (value, record) => (
            <NavLink to={`/users/edit/${record.key}`}>
                <ClickableRow>
                    {value}
                    {record.isMainUser && (
                        <CrownOutlined style={{ marginLeft: '8px', color: '#90908E' }} />
                    )}
                </ClickableRow>
            </NavLink>
        ),
    },
    {
        title: 'First name',
        dataIndex: 'firstName',
        sorter: true,
        clickable: true,
        render: (value, record) => (
            <NavLink to={`/users/edit/${record.key}`}>
                <ClickableRow>{value}</ClickableRow>
            </NavLink>
        ),
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true,
        clickable: true,
        render: (value, record) => (
            <NavLink to={`/users/edit/${record.key}`}>
                <UsersTableEmail>{value}</UsersTableEmail>
            </NavLink>
        ),
    },
    {
        title: 'Account type',
        sorter: true,
        dataIndex: 'accountRole',
        render: (value, record) => (
            <span>
                {record.isMainUser
                    ? 'Subscription Admin'
                    : value?.replace('Account', '') || 'Admin'}
            </span>
        ),
    },
    {
        title: 'Account created',
        sorter: true,
        dataIndex: 'accountCreated',
        render: (value) => <UsersTableGraySpan>{toShortLocalDate(value)}</UsersTableGraySpan>,
    },
    {
        title: 'Last Login',
        sorter: true,
        dataIndex: 'lastLoginTime',
        render: (value) => <UsersTableGraySpan>{toLocalShortDateTime(value)}</UsersTableGraySpan>,
    },
];
